import React, { useCallback, useContext, useEffect, useState } from 'react';
import { getContextModel } from '../../../../services/edge/ContexteService';
import {
  ContextBondTypes,
  DefaultSelectProps,
  ERROR,
} from '../../../../services/common/Constants';
import { Context } from '../../../../states/Store';
import style from './style';
import i18next from 'i18next';
import { FormGroup, FormLabel, MenuItem, TextField } from '@mui/material';

const ContextTypes = ({ formId, setContextModelId, setContextAttributeType, setIsSelectingContext }) => {
  const { classes } = style();
  const [state, dispatch] = useContext(Context);
  const contextModels = state.contextModels;

  const [selectedModel, setSelectedModel] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [modelError, setModelError] = useState(false);
  const [typeError, setTypeError] = useState(false);

  const fetchContextModels = useCallback(async () => {
    try {
      await getContextModel(state.account.id, dispatch);
    } catch (e) {
      dispatch({
        type: 'ALERT',
        alert: { type: ERROR, msg: 'INTERNAL_ERROR' },
      });
    }
  }, [state.account.id, dispatch]);

  useEffect(() => {
    fetchContextModels();
  }, [fetchContextModels]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const hasModel = !!selectedModel;
    const hasType = !!selectedType;

    setModelError(!hasModel);
    setTypeError(!hasType);

    if (hasModel && hasType) {
      const model = contextModels.find((c) => c.name === selectedModel);
      setContextModelId(model.id);
      setContextAttributeType(selectedType);
      setIsSelectingContext(false);
    }
  };

  return (
    <form id={formId} onSubmit={handleSubmit} className={classes.formContainer}>
      <div className={classes.inputBlock}>
        <FormLabel className={classes.formLabel}>
          {`${i18next.t('adminSettings.contextModel')} * `}
        </FormLabel>
        <FormGroup>
          <TextField
            id="contextModelSelect"
            variant="outlined"
            select
            value={selectedModel}
            error={modelError}
            helperText={typeError ? i18next.t("infos.required") : ""}
            onChange={(e) => {
              setSelectedModel(e.target.value);
              setModelError(false);
            }}
            className={classes.textField}
            SelectProps={{
              ...DefaultSelectProps,
              displayEmpty: true,
              renderValue: (selected) =>
                !selected ? (
                  <span className={classes.placeholder}>
                    {i18next.t('thirdpartySheet.contextTp.selectContextPlaceholder')}
                  </span>
                ) : (
                  <span>{selected}</span>
                ),
            }}
          >
            {contextModels.map((model) => (
              <MenuItem key={model.name} value={model.name}>
                {model.name}
              </MenuItem>
            ))}
          </TextField>
        </FormGroup>
      </div>

      <div className={classes.inputBlock}>
        <FormLabel className={classes.formLabel}>
          {`${i18next.t('adminSettings.attributType')} * `}
        </FormLabel>
        <FormGroup>
          <TextField
            id="attributeTypeSelect"
            variant="outlined"
            select
            value={selectedType}
            error={typeError}
            helperText={typeError ? i18next.t("infos.required") : ""}
            onChange={(e) => {
              setSelectedType(e.target.value);
              setTypeError(false);
            }}
            className={classes.textField}
            SelectProps={{
              ...DefaultSelectProps,
              displayEmpty: true,
              renderValue: (selected) =>
                !selected ? (
                  <span className={classes.placeholder}>
                    {i18next.t('adminSettings.selectAttributType')}
                  </span>
                ) : (
                  <span>{selected}</span>
                ),
            }}
          >
            {Object.keys(ContextBondTypes).map((type) => (
              <MenuItem key={ContextBondTypes[type]} value={ContextBondTypes[type]}>
                {i18next.t(`attributes.${ContextBondTypes[type]}`)}
              </MenuItem>
            ))}
          </TextField>
        </FormGroup>
      </div>
    </form>
  );
};

export default ContextTypes;
